module.exports = __webpack_public_path__ + "img/13.886b093f.jpg";